export enum StatusCode {
  PendingOnApplicant = 0,
  PendingOnInitialReview = 1,
  PendingOnPayment = 2,
  PendingOnCRM = 3,
  Completed = 4,
  InitialStatus = 5,
  NewTrip = 6,
  Canceled = 7,
  PendingOnClosingRequest = 8,
  PendingOnModification = 9,
  PendingOnPaymentGateway = 10,
  PendingOnOriginalDocuments = 11,
  InitiallyRejected = 12,
  Approved = 13,
  Rejected = 14,
  PendingOnUploadingScannedDocument = 15,
  PendingOnReceiveOriginalDocuments = 16,
  CoveredByInsuranceCompany = 17,
  PendingOnNationalAffairsReview = 18,
  PendingOnReview = 19,
  ProcessingRequest = 20,
  NoSufficientEvidence = 21,
  NotApplicable = 22,
  PendingOnMissionOfficer = 23,
  PendingOnConcernedDepartmentOfficer = 24,
  Closed = 25,
  PendingInformingApplicant = 26,
  ItemFound = 27,
  ItemNotFound = 28,
  ItemFoundAndWillBeSentToUAE = 29,
  CertificateIsReadyAtMission = 30,
  CertificateIsReadyAtMOFA = 31,
  PendingDelivery = 32,
  PendingAttestation = 33,
  PendingOnApplicantToReciveID = 34,
  UnderRevision = 41,
  WaitingForDetails = 40,
  PendingOnAppointment = 43,
  PendingOnDelivery = 45,
  PendingAppoval = 46,
  PendingUploadingAttachments = 47,
  SentforCorrection = 48,
  PendingUpdatingAttachments = 49,
  Draft = 50,
  PendingAddingMembers = 51,
  PendingUpdatingMembers = 52,
  ApprovedAndCompleted = 53,
  RejectedAndCompleted = 54,
  PendingOnUpdateDeliveryInformation = 56,
  Apologized = 59

}
